import React from "react"
import { useFormikContext } from "formik"
import { getAttr } from "src/helpers"
import { ButtonGroup, Button as ButtonUI } from "@mui/material";
import { Tooltip } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import { MODULES_LABELS } from "src/modules/admin/UIHelpers"
import SVG from "react-inlinesvg"
import { toAbsoluteUrl } from "src/helpers"

const ButtonField = ({
  field, // { name, value, onChange, onBlur }
  form, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  color,
  buttonText, // Custom button text
  icon, // Icon name or emoji
  svgIcon, // SVG icon path
  variant = "outline-primary", // Button variant
  inputGroupClassName = "form-group",
  hide = false,
  disabled = false,
  size = 12,
  onClick,
  ...props
}) => {
  const formik = useFormikContext()
  
  const getCurrentLivraison = () => {
    try {
      const pathParts = field.name.split('.');
      
      if (pathParts.length >= 2 && pathParts[0] === 'livraisons') {
        const indexStr = pathParts[1];
        const index = parseInt(indexStr, 10);
        
        if (!isNaN(index) && formik.values.livraisons && formik.values.livraisons[index]) {
          return formik.values.livraisons[index];
        }
      }
      
      return formik.values;
    } catch (error) {
      console.error("Error getting livraison:", error);
      return formik.values;
    }
  }
  
  // Evaluate the disabled function with the proper context
  const evaluateDisabled = () => {
    try {
      if (typeof disabled === 'function') {
        const row = getCurrentLivraison();
        console.log(disabled(row))
        return disabled(row);
      }
      return disabled;
    } catch (error) {
      console.error("Error evaluating disabled:", error);
      return false; // Default to enabled if there's an error
    }
  }
  
  const isDisabled = evaluateDisabled();

  // Don't render if hidden
  if (hide) return null
  // Determine button content
  const getButtonContent = () => {
    const text = buttonText;
    
    if (svgIcon) {
      return (
        <>
          <SVG src={toAbsoluteUrl(svgIcon)}  />
        </>
      );
    }
    
    if (icon) {
      return (
        <>
          <span style={{ marginRight: text ? '5px' : '0' }}>{icon}</span>
        </>
      );
    }
    
    return text || label;
  };

  // Check if it's icon-only button
  const isIconOnly = (svgIcon || icon) && !buttonText;
  const isLinkStyle = !svgIcon && !icon;

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Tooltip title={label} arrow>
        <ButtonUI
          onClick={() => {
            if (typeof onClick === 'function') {
              onClick(getAttr(formik.values, field.name))
            }
          }}
          disabled={isDisabled}
          sx={isLinkStyle ? {
            textTransform: 'none',
            color: '#1976d2',
            padding: '4px 8px',
            minWidth: 'auto',
            fontSize: '0.875rem',
            fontWeight: 500,
            '&:hover': {
              backgroundColor: 'rgba(25, 118, 210, 0.08)',
              color: '#1565c0'
            }
          } : {}}
        >
          {getButtonContent()}
        </ButtonUI>
      </Tooltip>
    </div>
  )
}

export default ButtonField